// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form[data-v-a8871494]{height:100%;max-width:700px;min-width:100%}@media(min-width:768px){.form[data-v-a8871494]{margin:50px 0;min-width:700px}}.form form textarea[data-v-a8871494]{width:100%}.form form fieldset[data-v-a8871494]{margin:20px 0}.pagination__button[data-v-a8871494]{background-color:#1c1c1e}.pagination__button[data-v-a8871494]:hover{background-color:#2c2c2e}.pagination__button svg[data-v-a8871494]{fill:#9ae17b}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
